
import { defineComponent } from 'vue';
import Temporizador from './Temporizador.vue';

export default defineComponent({
   name: "Formulario-nome",
   data(){
      return {
         descricao: ''
      }
   },
   emits: ['aoSalvarTarefa'],
   methods: {
      finalizarTarefa(tempoDecorrido : number) : void {
         this.$emit('aoSalvarTarefa', {
            duracaoEmSegundos: tempoDecorrido,
            descricao: this.descricao
         })
         this.descricao = ''
      }
   },
   components: { Temporizador }
})
